import { render, staticRenderFns } from "./UsersPrivilegeAddictiveStuffClient.vue?vue&type=template&id=002ec270&scoped=true&"
import script from "./UsersPrivilegeAddictiveStuffClient.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeAddictiveStuffClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ec270",
  null
  
)

export default component.exports